/**
 * Insere funcionalidades adicionais nos objetos Button
 *
 * @author Wellington
 * @since 2025-05-22
 * @version 1.0.0
 * @license Comercial
 */

const htmlTableElementExtensions = {
  /**
   * adiciona a tag <tbody>
   */
  addBody() {
    const tbody = document.createElement('tbody');
    this.appendChild(tbody);
    return tbody;
  },

  /**
   * adiciona a tag <tfoot>
   */
  addFoot() {
    const tfoot = document.createElement('tfoot');
    this.appendChild(tfoot);
    return tfoot;
  },

  /**
   * adiciona a tag <thead>
   */
  addHead() {
    const thead = document.createElement('thead');
    this.appendChild(thead);
    return thead;
  }
};

/**
 * Adiciona os métodos ao protótipo de HTMLTableElement
 */
const extendHTMLTableElement = () => {
  Object.entries(htmlTableElementExtensions).forEach(([key, value]) => {
    if (!HTMLTableElement.prototype[key]) {
      HTMLTableElement.prototype[key] = value;
    } else {
      console.warn(`HTMLTableElement.prototype.${key} já existe e não será sobrescrito.`);
    }
  });
};

export default extendHTMLTableElement;
